module.exports = __webpack_public_path__ + "img/barrier.267b7c8d.png";